import { useEffect, useRef, useState } from "react"
import Container from "./Container"

type Props = {
  jsonConfig: {
    content: string
  }
}

/**
 * 用 iframe 隔离了一下样式，并且自动设置了个高度
 */
export function ShopModuleCustomPC({ jsonConfig }: Props) {
  const ifm = useRef<HTMLIFrameElement>()

  useEffect(() => {
    const innerDoc = ifm.current.contentWindow.document
    const innerBody = innerDoc.body

    innerBody.style.margin = "0"
    innerBody.style.padding = "0"
    innerBody.innerHTML = jsonConfig.content
    innerDoc.documentElement.style.overflowY = "hidden"

    const height = innerDoc.documentElement.offsetHeight
    ifm.current.height = height + "px"

    // 看了下 iframe-resizer 的实现，除了 MutationObserver，就只关注了所有 <img /> 的加载
    // 我们富文本编辑器不支持插入 script，能改变高度就只有 <img /> 了
    innerBody.querySelectorAll("img").forEach((img) => {
      img.addEventListener("load", () => {
        const height = innerDoc.documentElement.offsetHeight
        ifm.current.height = height + "px"
      })
    })
    // TODO 没处理 <a/>

    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [])

  return (
    <Container>
      <iframe
        frameBorder="0"
        width="100%"
        style={{ overflow: "hidden" }}
        ref={ifm}
      ></iframe>
    </Container>
  )
}
